class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    if (this.notification) {
      this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    }
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    if (!this.notification) return;
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      if (typeof trapFocus === 'function') trapFocus(this.notification);
    }, { once: true });
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, dontOpen = false) {
      if (!parsedState) return;

      // 1. Button & Icon-Bubble aktualisieren
      if (parsedState.sections) {
          const sectionsToUpdate = [
            { id: 'cart-notification-button', selector: '.shopify-section' },
            { id: 'cart-icon-bubble', selector: '.shopify-section' }
          ];
          sectionsToUpdate.forEach(section => {
              const targetElement = document.getElementById(section.id);
              if (targetElement && parsedState.sections[section.id]) {
                  const parsedHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
                  if (parsedHTML) targetElement.innerHTML = parsedHTML;
              }
          });
      }

      // 2. Produkt(e) dynamisch generieren
      const productContainer = document.getElementById('cart-notification-product');
      if (productContainer) {
          const items = parsedState.items ? parsedState.items : (parsedState.id ? [parsedState] : []);
          
          // Identische Artikel herausfiltern, damit man sie nicht doppelt sieht
          const uniqueItems = [];
          const seenVariants = new Set();
          items.forEach(item => {
             const idToCheck = item.variant_id || item.id;
             if (idToCheck && !seenVariants.has(idToCheck)) {
                 seenVariants.add(idToCheck);
                 uniqueItems.push(item);
             }
          });

          if (uniqueItems.length > 0) {
              // Flex-Container für die Artikel
              let itemsHTML = '<div style="max-height: 40vh; overflow-y: auto; overflow-x: hidden; padding-right: 5px; display: flex; flex-direction: column; gap: 15px;">';
              
              uniqueItems.forEach(item => {
                  let title = item.product_title || item.title || 'Produkt';
                  
                  // Varianten-Text stylen ("Farbe: Schwarz")
                  let variantTextHTML = '';
                  if (item.options_with_values && item.options_with_values.length > 0) {
                      variantTextHTML = item.options_with_values.map(opt => `${opt.name}: ${opt.value}`).join('<br>');
                  } else if (item.variant_title && item.variant_title !== 'Default Title') {
                      variantTextHTML = item.variant_title.replace(' / ', '<br>');
                  }
                  
                  // URL für das Bild aufbereiten
                  let imageUrl = item.image || (item.featured_image ? item.featured_image.url : '');
                  if (imageUrl && !imageUrl.startsWith('http')) {
                      imageUrl = 'https:' + imageUrl; // Sichert Protokoll ab
                  }
                  
                  // HTML für das jeweilige Produkt
                  itemsHTML += `
                    <div style="display: flex; align-items: center; width: 100%;">
                      ${imageUrl ? `<img src="${imageUrl}" style="width: 70px; height: 70px; min-width: 70px; object-fit: cover; border-radius: 8px; margin-right: 15px; border: 1px solid rgba(0,0,0,0.05);" alt="${title}">` : ''}
                      <div style="flex: 1; text-align: left; display: flex; flex-direction: column; justify-content: center;">
                        <h3 style="margin: 0 0 5px 0; font-size: 1.4rem; font-weight: 600; line-height: 1.2; color: inherit;">${title}</h3>
                        ${variantTextHTML ? `<p style="margin: 0; font-size: 1.2rem; opacity: 0.7; line-height: 1.4;">${variantTextHTML}</p>` : ''}
                      </div>
                    </div>
                  `;
              });
              
              itemsHTML += '</div>';
              productContainer.innerHTML = itemsHTML;
          }
      }

      if (this.header && typeof this.header.reveal === 'function') this.header.reveal();
      if (!dontOpen) this.open();
  }

  // Alte Methoden sicherheitshalber behalten
  getSectionsToRender() {
    return [
      { id: 'cart-notification-product', selector: `[id="cart-notification-product-${this.cartItemKey}"]` },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;
    const domDocument = new DOMParser().parseFromString(html, 'text/html');
    const element = domDocument.querySelector(selector);
    return element ? element.innerHTML : domDocument.body.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (this.notification && target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);